import * as yup from 'yup';
import {asyncValidatorFormat} from './async-method';


yup.addMethod(yup.string, 'async', asyncValidatorFormat);


export const Yup = yup;
